import type { Column } from '~/ui/Table/types'

export const BURN_HISTORY_COLUMN: Array<Column> = [
  {
    name: 'TXN HASH',
    field: 'transactionHash',
  },
  {
    name: 'AGE',
    field: 'age',
    isToggleColumn: true,
    tooltip: 'click to toggle timestamp',
  },
  {
    name: 'DATETIME',
    field: 'unixTimeStamp',
    isToggleColumn: true,
    tooltip: 'click to toggle age',
  },
  {
    name: '🔥 AMOUNT',
    field: 'amount',
  },
]
